/* eslint-disable */
import Vue from "vue";
import App from "./App";
// import VueRouter from "vue-router";
// import { routes } from "./routes.js";

// Vue.use(VueRouter);

// const router = new VueRouter({
//   routes,
//   mode: "history"
//   //mode history so that no # are useds in url
// });

// Vue.config.productionTip = false;

// /* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   components: { App },
//   template: "<App/>"
// });
import VueRouter from "vue-router";
import { routes } from "./routes";

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history"
});
new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js